<template>
  <div class="chips-container">
    <div class="content">
      <v-text-field
        :placeholder="contentData.responses.text"
        v-model="textInput"
        @change="!isValidInput()"
        outlined
        solo
        flat
        block
        class="input"
        :rules="validationRules"
      ></v-text-field>
    </div>
    <div class="btns-wrap">
      <v-btn :disabled="!isValidInput()" depressed block class="primary-txt-btn __h68" @click="submitAnswer(true)">{{
        contentData.responses.submitbutton
      }}</v-btn>
      <v-btn
        depressed
        block
        class="grey-txt-btn __h68"
        @click="submitAnswer(false)"
        v-show="!contentData.hideCancelbutton"
        >{{ contentData.responses.cancelbutton }}</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textInput: "",
      contentData: {
        responses: {
          text: "placeholder text",
          submitbutton: "submit",
          cancelbutton: "cancel",
          submitButtonActions: {}
        },
        hideCancelbutton: false,
        validationMessage: "",
      },
      validationRules: [
        input => this.isValidInput(input) || this.contentData.validationMessage
      ]
    }
  },
  methods: {
    submitAnswer(answered) {
    // check if special action needs to be loaded
    if (this.contentData.responses?.submitButtonActions?.showLoading !== undefined){
      this.$emit("showLoadingModal", this.contentData.responses.submitButtonActions.showLoading);
    }

      let newInput = {}
      if (answered === true) {
        newInput = {
          textbox: {
            enteredText: this.$data.textInput,
            skipped: false,
          },
        }
      } else {
        newInput = {
          textbox: {
            skipped: true,
          },
        }
      }
      console.log(newInput)
      this.$emit("submitAnswer", newInput)
    },
    updateContent(executableSystemAction) {
      console.log("Inside updateContent for Textbox Card")

      let updatedContent = {
        responses: {
          text: executableSystemAction.guiTemplateContent.textbox.text,
          submitbutton: executableSystemAction.guiTemplateContent.submitbutton.text,
          cancelbutton: executableSystemAction.guiTemplateContent.cancelbutton.text,
          validations: executableSystemAction.guiTemplateContent.textbox.validation,
          submitButtonActions: executableSystemAction.guiTemplateContent.submitbutton.additionalActions
        },
        hideCancelbutton: executableSystemAction.guiTemplateContent.cancelbutton.hidden,
      }

      // reset textbox input
      this.$data.textInput = ""
      console.log(updatedContent)

      this.contentData = updatedContent
    },
    // validateInput validates the text input given by the user (used to display an error message and to toggle the submit button)
    // sets the validationMessage and returns true/false whether the user input is valid or not
    isValidInput() {
      if (this.textInput.length === 0) {
        return false
      }

      // Only run validations if validations are defined
      if ("validations" in this.contentData.responses && this.contentData.responses.validations !== undefined) {
        // go through validations and check for violoations
        for (let validation of this.contentData.responses.validations) {
          let re = new RegExp(validation.regex)
          if (re.test(this.$data.textInput) === false) {
            // set error message for violated validation rule
            this.contentData.validationMessage = validation.message
            return false
          }
        }
      }
      this.contentData.validationMessage = ""
      return true
    },
  },
  mounted() {
    // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
    this.$nextTick(() => {
      this.$emit("readyToUpdate")
    })
  },
}
</script>

<style></style>
